import React from 'react'
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../Utils/_assets/sass/call-ticker.scss";
import { toAbsoluteUrl } from "../../../Utils/_helpers";
import OpcSelect from "../../components/select/src";

const getOpcSelectIcon = () => {
  return (
    <span className="">
      <img
        alt=""
        className="t-dp"
        src={toAbsoluteUrl("/media/sr/icons/sr_number.svg")}
      />
    </span>
  );
};

export const SRNumInput = (props) => {
  const dispatch = useDispatch();

  const [selected, setSelected] = useState("");
  const onSelect = (code) => {
    setSelected(code);
    dispatch({
      type: "onSetTickerState",
      payload: { ticker_initial_srnumber: code, ticker_initial_callerid: "" },
    });
    props.onEvent({ type: "c2c_form::set", key: "sr_number", value: code });
  };

  const showSelectedLabel = true;
  const showSecondarySelectedLabel = false;
  const showOptionLabel = true;
  const showSecondaryOptionLabel = true;
  const searchable = true;

  const [customLabels, setCustomLabels] = useState({});

  const [valueCodes, setValueCodes] = useState([]);

  const userPlans = useSelector((state) => {
    return state.auth.plans;
  });

  useEffect(() => {
    const customLabels1 = {};
    const values_codes = [];
    onSelect('');
    userPlans.objects.map((plan, i) => {
      plan.numbers.map((number, j) => {
        if (!number.is_expired && number.cli_type === "NONE" && props.is_promotional === number.is_promotional) {
            let option = {
              icon: getOpcSelectIcon(),
              data: { plan: plan, number: number },
              primary: number.phone,
              secondary: plan.plan.plan_name,
            };
            let key = number.phone;
            customLabels1[key] = option;
            values_codes.push(key);
        }
      });
    });

    setValueCodes(values_codes);
    setCustomLabels(customLabels1);
    return () => {
      // onSelect('')
    };
  }, [userPlans, props.is_promotional]);
  useEffect(() => {
    if (props.ticker_initial_srnumber) {
      onSelect(props.ticker_initial_srnumber);
    }
  }, [props.ticker_initial_srnumber]);

  return (
    <div className="row tel-select">
      <div className="col-12 flex-d">
        <div className="opc-select demo-wrapper">
          <OpcSelect
            type="sr_number"
            placeholder="SR Number"
            searchPlaceholder="Search SR Number"
            selected={selected}
            onSelect={onSelect}
            showSelectedLabel={showSelectedLabel}
            showSecondarySelectedLabel={showSecondarySelectedLabel}
            showOptionLabel={showOptionLabel}
            showSecondaryOptionLabel={showSecondaryOptionLabel}
            customLabels={customLabels}
            countries={valueCodes}
            searchable={searchable}
            placeholderIcon={getOpcSelectIcon()}
            optionItemIcon={getOpcSelectIcon()}
            selectButtonClassName={"ticker-input2 opselect-form-field-outline" }
          />
        </div>
      </div>
    </div>
  );
};
